/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateTickets = /* GraphQL */ `
  subscription OnCreateTickets($filter: ModelSubscriptionTicketsFilterInput) {
    onCreateTickets(filter: $filter) {
      id
      fechaDeTicket
      horaApertura
      fechaDeAtendido
      horaAtendido
      nombreSolicitante
      numero
      modulo
      titulo
      descripcion
      estatus
      asignadoA
      tipo
      prioridad
      comentariosUsuario
      RespuestaSoporte
      comentariosSoporte
      activo
      archivo
      image
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTickets = /* GraphQL */ `
  subscription OnUpdateTickets($filter: ModelSubscriptionTicketsFilterInput) {
    onUpdateTickets(filter: $filter) {
      id
      fechaDeTicket
      horaApertura
      fechaDeAtendido
      horaAtendido
      nombreSolicitante
      numero
      modulo
      titulo
      descripcion
      estatus
      asignadoA
      tipo
      prioridad
      comentariosUsuario
      RespuestaSoporte
      comentariosSoporte
      activo
      archivo
      image
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTickets = /* GraphQL */ `
  subscription OnDeleteTickets($filter: ModelSubscriptionTicketsFilterInput) {
    onDeleteTickets(filter: $filter) {
      id
      fechaDeTicket
      horaApertura
      fechaDeAtendido
      horaAtendido
      nombreSolicitante
      numero
      modulo
      titulo
      descripcion
      estatus
      asignadoA
      tipo
      prioridad
      comentariosUsuario
      RespuestaSoporte
      comentariosSoporte
      activo
      archivo
      image
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateTicketStatus = /* GraphQL */ `
  subscription OnCreateTicketStatus(
    $filter: ModelSubscriptionTicketStatusFilterInput
  ) {
    onCreateTicketStatus(filter: $filter) {
      id
      ticketsID
      numero
      fecha
      hora
      campoModificado
      valorAnterior
      valorActual
      cambioSoporte
      cambioUsuario
      respuestaUsuario
      respuestaSoporte
      usuario
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTicketStatus = /* GraphQL */ `
  subscription OnUpdateTicketStatus(
    $filter: ModelSubscriptionTicketStatusFilterInput
  ) {
    onUpdateTicketStatus(filter: $filter) {
      id
      ticketsID
      numero
      fecha
      hora
      campoModificado
      valorAnterior
      valorActual
      cambioSoporte
      cambioUsuario
      respuestaUsuario
      respuestaSoporte
      usuario
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTicketStatus = /* GraphQL */ `
  subscription OnDeleteTicketStatus(
    $filter: ModelSubscriptionTicketStatusFilterInput
  ) {
    onDeleteTicketStatus(filter: $filter) {
      id
      ticketsID
      numero
      fecha
      hora
      campoModificado
      valorAnterior
      valorActual
      cambioSoporte
      cambioUsuario
      respuestaUsuario
      respuestaSoporte
      usuario
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateNotificaciones = /* GraphQL */ `
  subscription OnCreateNotificaciones(
    $filter: ModelSubscriptionNotificacionesFilterInput
  ) {
    onCreateNotificaciones(filter: $filter) {
      id
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateNotificaciones = /* GraphQL */ `
  subscription OnUpdateNotificaciones(
    $filter: ModelSubscriptionNotificacionesFilterInput
  ) {
    onUpdateNotificaciones(filter: $filter) {
      id
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteNotificaciones = /* GraphQL */ `
  subscription OnDeleteNotificaciones(
    $filter: ModelSubscriptionNotificacionesFilterInput
  ) {
    onDeleteNotificaciones(filter: $filter) {
      id
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateNotificacionesNuevas = /* GraphQL */ `
  subscription OnCreateNotificacionesNuevas(
    $filter: ModelSubscriptionNotificacionesNuevasFilterInput
  ) {
    onCreateNotificacionesNuevas(filter: $filter) {
      id
      NotificacionID
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateNotificacionesNuevas = /* GraphQL */ `
  subscription OnUpdateNotificacionesNuevas(
    $filter: ModelSubscriptionNotificacionesNuevasFilterInput
  ) {
    onUpdateNotificacionesNuevas(filter: $filter) {
      id
      NotificacionID
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteNotificacionesNuevas = /* GraphQL */ `
  subscription OnDeleteNotificacionesNuevas(
    $filter: ModelSubscriptionNotificacionesNuevasFilterInput
  ) {
    onDeleteNotificacionesNuevas(filter: $filter) {
      id
      NotificacionID
      modulo
      Accion
      notificacion
      fecha
      hora
      leido
      usuarioDe
      usuarioPara
      paraSoporte
      recibaSerialID
      tipo
      notifInicialID
      autorizacion
      autorizacionID
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateProducto = /* GraphQL */ `
  subscription OnCreateProducto($filter: ModelSubscriptionProductoFilterInput) {
    onCreateProducto(filter: $filter) {
      id
      clienteID
      cotizacionID
      piezasXRack
      rackTipo
      numerodeParte
      numerodeParteSalida
      clienteAsociadoID
      numerodeParteAsociado
      sporNP
      poEmbarques
      descripcion
      divisa
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      cantidadporAnio
      documentodeEspecificaciones
      documento1
      documento2
      documento3
      documento4
      documento5
      documento6
      documento7
      documento8
      documento9
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      image1
      image2
      image3
      image4
      image5
      image6
      image7
      image8
      image9
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProducto = /* GraphQL */ `
  subscription OnUpdateProducto($filter: ModelSubscriptionProductoFilterInput) {
    onUpdateProducto(filter: $filter) {
      id
      clienteID
      cotizacionID
      piezasXRack
      rackTipo
      numerodeParte
      numerodeParteSalida
      clienteAsociadoID
      numerodeParteAsociado
      sporNP
      poEmbarques
      descripcion
      divisa
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      cantidadporAnio
      documentodeEspecificaciones
      documento1
      documento2
      documento3
      documento4
      documento5
      documento6
      documento7
      documento8
      documento9
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      image1
      image2
      image3
      image4
      image5
      image6
      image7
      image8
      image9
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProducto = /* GraphQL */ `
  subscription OnDeleteProducto($filter: ModelSubscriptionProductoFilterInput) {
    onDeleteProducto(filter: $filter) {
      id
      clienteID
      cotizacionID
      piezasXRack
      rackTipo
      numerodeParte
      numerodeParteSalida
      clienteAsociadoID
      numerodeParteAsociado
      sporNP
      poEmbarques
      descripcion
      divisa
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      cantidadporAnio
      documentodeEspecificaciones
      documento1
      documento2
      documento3
      documento4
      documento5
      documento6
      documento7
      documento8
      documento9
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      image1
      image2
      image3
      image4
      image5
      image6
      image7
      image8
      image9
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCliente = /* GraphQL */ `
  subscription OnCreateCliente($filter: ModelSubscriptionClienteFilterInput) {
    onCreateCliente(filter: $filter) {
      id
      cliente
      activo
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      facturaTipo
      requiereIVA
      porcentajeIVA
      rfc
      razonSocial
      usoCFDI
      billTo
      shipTo
      telefono
      correo
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      nombreContacto1
      puestoContacto1
      telefonoContacto1
      correoContacto1
      nombreContacto2
      puestoContacto2
      telefonoContacto2
      correoContacto2
      nombreContacto3
      puestoContacto3
      telefonoContacto3
      correoContacto3
      nombreContacto4
      puestoContacto4
      telefonoContacto4
      correoContacto4
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCliente = /* GraphQL */ `
  subscription OnUpdateCliente($filter: ModelSubscriptionClienteFilterInput) {
    onUpdateCliente(filter: $filter) {
      id
      cliente
      activo
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      facturaTipo
      requiereIVA
      porcentajeIVA
      rfc
      razonSocial
      usoCFDI
      billTo
      shipTo
      telefono
      correo
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      nombreContacto1
      puestoContacto1
      telefonoContacto1
      correoContacto1
      nombreContacto2
      puestoContacto2
      telefonoContacto2
      correoContacto2
      nombreContacto3
      puestoContacto3
      telefonoContacto3
      correoContacto3
      nombreContacto4
      puestoContacto4
      telefonoContacto4
      correoContacto4
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCliente = /* GraphQL */ `
  subscription OnDeleteCliente($filter: ModelSubscriptionClienteFilterInput) {
    onDeleteCliente(filter: $filter) {
      id
      cliente
      activo
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      facturaTipo
      requiereIVA
      porcentajeIVA
      rfc
      razonSocial
      usoCFDI
      billTo
      shipTo
      telefono
      correo
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      nombreContacto1
      puestoContacto1
      telefonoContacto1
      correoContacto1
      nombreContacto2
      puestoContacto2
      telefonoContacto2
      correoContacto2
      nombreContacto3
      puestoContacto3
      telefonoContacto3
      correoContacto3
      nombreContacto4
      puestoContacto4
      telefonoContacto4
      correoContacto4
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateClienteContactos = /* GraphQL */ `
  subscription OnCreateClienteContactos(
    $filter: ModelSubscriptionClienteContactosFilterInput
  ) {
    onCreateClienteContactos(filter: $filter) {
      id
      clienteID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateClienteContactos = /* GraphQL */ `
  subscription OnUpdateClienteContactos(
    $filter: ModelSubscriptionClienteContactosFilterInput
  ) {
    onUpdateClienteContactos(filter: $filter) {
      id
      clienteID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteClienteContactos = /* GraphQL */ `
  subscription OnDeleteClienteContactos(
    $filter: ModelSubscriptionClienteContactosFilterInput
  ) {
    onDeleteClienteContactos(filter: $filter) {
      id
      clienteID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateProveedores = /* GraphQL */ `
  subscription OnCreateProveedores(
    $filter: ModelSubscriptionProveedoresFilterInput
  ) {
    onCreateProveedores(filter: $filter) {
      id
      Proveedor
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      rfc
      razonSocial
      telefono
      correo
      activo
      autorizado
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProveedores = /* GraphQL */ `
  subscription OnUpdateProveedores(
    $filter: ModelSubscriptionProveedoresFilterInput
  ) {
    onUpdateProveedores(filter: $filter) {
      id
      Proveedor
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      rfc
      razonSocial
      telefono
      correo
      activo
      autorizado
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProveedores = /* GraphQL */ `
  subscription OnDeleteProveedores(
    $filter: ModelSubscriptionProveedoresFilterInput
  ) {
    onDeleteProveedores(filter: $filter) {
      id
      Proveedor
      descripcion
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      rfc
      razonSocial
      telefono
      correo
      activo
      autorizado
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      image
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateProveedorContactos = /* GraphQL */ `
  subscription OnCreateProveedorContactos(
    $filter: ModelSubscriptionProveedorContactosFilterInput
  ) {
    onCreateProveedorContactos(filter: $filter) {
      id
      proveedorID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      sucursal
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProveedorContactos = /* GraphQL */ `
  subscription OnUpdateProveedorContactos(
    $filter: ModelSubscriptionProveedorContactosFilterInput
  ) {
    onUpdateProveedorContactos(filter: $filter) {
      id
      proveedorID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      sucursal
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProveedorContactos = /* GraphQL */ `
  subscription OnDeleteProveedorContactos(
    $filter: ModelSubscriptionProveedorContactosFilterInput
  ) {
    onDeleteProveedorContactos(filter: $filter) {
      id
      proveedorID
      nombreContacto
      puestoContacto
      telefonoContacto
      correoContacto
      sucursal
      domicilio
      colonia
      ciudad
      estado
      pais
      codigoPostal
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateICuarentena = /* GraphQL */ `
  subscription OnCreateICuarentena(
    $filter: ModelSubscriptionICuarentenaFilterInput
  ) {
    onCreateICuarentena(filter: $filter) {
      id
      recibaSerialID
      recibaSerialMPID
      lote
      serial
      serialRecibaBTI
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasaRecuperar
      inspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentarios
      activo
      fechaIngreso
      horaIngreso
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateICuarentena = /* GraphQL */ `
  subscription OnUpdateICuarentena(
    $filter: ModelSubscriptionICuarentenaFilterInput
  ) {
    onUpdateICuarentena(filter: $filter) {
      id
      recibaSerialID
      recibaSerialMPID
      lote
      serial
      serialRecibaBTI
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasaRecuperar
      inspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentarios
      activo
      fechaIngreso
      horaIngreso
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteICuarentena = /* GraphQL */ `
  subscription OnDeleteICuarentena(
    $filter: ModelSubscriptionICuarentenaFilterInput
  ) {
    onDeleteICuarentena(filter: $filter) {
      id
      recibaSerialID
      recibaSerialMPID
      lote
      serial
      serialRecibaBTI
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasaRecuperar
      inspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentarios
      activo
      fechaIngreso
      horaIngreso
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUbicacion = /* GraphQL */ `
  subscription OnCreateUbicacion(
    $filter: ModelSubscriptionUbicacionFilterInput
  ) {
    onCreateUbicacion(filter: $filter) {
      id
      recibaID
      RecibaSerialesID
      recibaSerialMPID
      fechaDeReciba
      ubicaciondeReciba
      lote
      serial
      serialRecibaBTI
      cantidad
      ubicacion
      locacion
      espacioOcupado
      mesaInspeccion
      comentarios
      activo
      orden
      fechaIngreso
      horaIngreso
      fechaSalida
      horaSalida
      ultimo
      ultimoAnterior
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUbicacion = /* GraphQL */ `
  subscription OnUpdateUbicacion(
    $filter: ModelSubscriptionUbicacionFilterInput
  ) {
    onUpdateUbicacion(filter: $filter) {
      id
      recibaID
      RecibaSerialesID
      recibaSerialMPID
      fechaDeReciba
      ubicaciondeReciba
      lote
      serial
      serialRecibaBTI
      cantidad
      ubicacion
      locacion
      espacioOcupado
      mesaInspeccion
      comentarios
      activo
      orden
      fechaIngreso
      horaIngreso
      fechaSalida
      horaSalida
      ultimo
      ultimoAnterior
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUbicacion = /* GraphQL */ `
  subscription OnDeleteUbicacion(
    $filter: ModelSubscriptionUbicacionFilterInput
  ) {
    onDeleteUbicacion(filter: $filter) {
      id
      recibaID
      RecibaSerialesID
      recibaSerialMPID
      fechaDeReciba
      ubicaciondeReciba
      lote
      serial
      serialRecibaBTI
      cantidad
      ubicacion
      locacion
      espacioOcupado
      mesaInspeccion
      comentarios
      activo
      orden
      fechaIngreso
      horaIngreso
      fechaSalida
      horaSalida
      ultimo
      ultimoAnterior
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateReciba = /* GraphQL */ `
  subscription OnCreateReciba($filter: ModelSubscriptionRecibaFilterInput) {
    onCreateReciba(filter: $filter) {
      id
      numero
      serialesID
      clienteID
      cliente
      fechaDeReciba
      horaDeReciba
      dueDate
      cantidadRecibida
      po
      status
      quienInspecciono
      comentarios
      packings
      lotes
      LoteBTI
      numerosdeParte
      descripcionesNP
      contenedores
      seriales
      serialesBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateReciba = /* GraphQL */ `
  subscription OnUpdateReciba($filter: ModelSubscriptionRecibaFilterInput) {
    onUpdateReciba(filter: $filter) {
      id
      numero
      serialesID
      clienteID
      cliente
      fechaDeReciba
      horaDeReciba
      dueDate
      cantidadRecibida
      po
      status
      quienInspecciono
      comentarios
      packings
      lotes
      LoteBTI
      numerosdeParte
      descripcionesNP
      contenedores
      seriales
      serialesBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteReciba = /* GraphQL */ `
  subscription OnDeleteReciba($filter: ModelSubscriptionRecibaFilterInput) {
    onDeleteReciba(filter: $filter) {
      id
      numero
      serialesID
      clienteID
      cliente
      fechaDeReciba
      horaDeReciba
      dueDate
      cantidadRecibida
      po
      status
      quienInspecciono
      comentarios
      packings
      lotes
      LoteBTI
      numerosdeParte
      descripcionesNP
      contenedores
      seriales
      serialesBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRecibaSeriales = /* GraphQL */ `
  subscription OnCreateRecibaSeriales(
    $filter: ModelSubscriptionRecibaSerialesFilterInput
  ) {
    onCreateRecibaSeriales(filter: $filter) {
      id
      numero
      serialRecibaBTI
      recibaSerialMPID
      sporNP
      krecibaNP
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasNoAceptadas
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRecibaSeriales = /* GraphQL */ `
  subscription OnUpdateRecibaSeriales(
    $filter: ModelSubscriptionRecibaSerialesFilterInput
  ) {
    onUpdateRecibaSeriales(filter: $filter) {
      id
      numero
      serialRecibaBTI
      recibaSerialMPID
      sporNP
      krecibaNP
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasNoAceptadas
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRecibaSeriales = /* GraphQL */ `
  subscription OnDeleteRecibaSeriales(
    $filter: ModelSubscriptionRecibaSerialesFilterInput
  ) {
    onDeleteRecibaSeriales(filter: $filter) {
      id
      numero
      serialRecibaBTI
      recibaSerialMPID
      sporNP
      krecibaNP
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasNoAceptadas
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRecibaSerialesMP = /* GraphQL */ `
  subscription OnCreateRecibaSerialesMP(
    $filter: ModelSubscriptionRecibaSerialesMPFilterInput
  ) {
    onCreateRecibaSerialesMP(filter: $filter) {
      id
      recibaSerialID
      rsUpdatedAt
      sporNP
      krecibaNP
      numero
      serialRecibaBTI
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasNoAceptadas
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRecibaSerialesMP = /* GraphQL */ `
  subscription OnUpdateRecibaSerialesMP(
    $filter: ModelSubscriptionRecibaSerialesMPFilterInput
  ) {
    onUpdateRecibaSerialesMP(filter: $filter) {
      id
      recibaSerialID
      rsUpdatedAt
      sporNP
      krecibaNP
      numero
      serialRecibaBTI
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasNoAceptadas
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRecibaSerialesMP = /* GraphQL */ `
  subscription OnDeleteRecibaSerialesMP(
    $filter: ModelSubscriptionRecibaSerialesMPFilterInput
  ) {
    onDeleteRecibaSerialesMP(filter: $filter) {
      id
      recibaSerialID
      rsUpdatedAt
      sporNP
      krecibaNP
      numero
      serialRecibaBTI
      autNoFIFO
      autPNoFIFO1
      autPNoFIFO2
      autPPNoFIFOComentTIOA1
      autPPNoFIFOComentTIOA2
      solNoFIFO
      solNoFIFOModulo
      solPNoFIFOMotivos
      autPNoFIFOComentTIOA
      clienteID
      cliente
      fechaDeReciba
      fechayHoraDeReciba
      MFGFecha
      eViajeraImpresas
      eEmbarquesImpresas
      materialEn
      materialEnCantidad
      empaquesAEmbarcar
      empaquesEmbarcados
      packing
      packingindex
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      numerodeParte
      numerodeParteSalida
      poEmbarques
      piezasXRack
      rackTipo
      descripcion
      cantidadporParte
      recibaID
      lote
      peso
      po
      sombreado
      serial
      cantidadRecibida
      cantidadRecibidaOriginal
      ultimaUbicacion
      rubicaciones
      ubicacion
      locacion
      espacioOcupado
      fechaDeUbicacion
      horaDeUbicacion
      defectoCuarentena
      cantidadPlaneada
      cantidadPlaneadaPC
      piezasPintadasExtra
      piezasPintadas
      piezasPintadasPC
      PiezasEPintadas
      PiezasEPintadasPC
      PiezasENRecuperadas
      PiezasENRecuperadasPC
      piezasEmbarcadas
      piezasAEmbarcar
      piezasenAlmacen
      piezasenCuarentena
      piezasenCarga
      piezasenCargaPC
      piezasenPintado
      piezasenPintadoPC
      piezasInspeccion
      piezasCalidad
      piezasInspeccionPC
      piezasCalidadPC
      piezasNoAceptadasPC
      piezasNoAceptadas
      piezasIRecuperacion
      piezasCRecuperacion
      PiezasCtnaRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      piezasNRecuperadasPC
      piezasCtnaRecuperadas
      piezasCtnaNRecuperadas
      piezasCtnaNAEmbarcar
      piezasCtnaEmbarcadas
      piezasCtnaPintadas
      piezasCtnaPintadasPC
      piezasFacturadas
      facturacionSEID
      MesasInspeccion
      cUnaInspeccion
      racks
      ciclos
      ultimoRack
      numeroCarga
      racksPC
      ciclosPC
      ultimoRackPC
      numeroCargaPC
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      noAceptadasFechaHoraPC
      cargaFechaHoraPC
      pintadoFechaHoraPC
      calidadFechaHoraPC
      registroCarga
      registroCargaPC
      registroPintado
      registroPintadoPC
      registroInspeccionF
      registroInspeccionFPC
      empaqueSinDanos
      materialCorrecto
      materialNContaminado
      materialSinDefectosOvios
      usuarioIncoming
      pruebaSolubilidad
      espesor
      omitirCarga
      omitirCargaComent
      omitirPintado
      omitirPintadoComent
      omitirIFinal
      omitirIFinalComent
      orden
      status
      UltimaInspeccionCuarentena
      quienInspecciono
      comentariosdeinspeccion
      comentariosdecuarentena
      piezasEnPlanta
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateAutorizaciones = /* GraphQL */ `
  subscription OnCreateAutorizaciones(
    $filter: ModelSubscriptionAutorizacionesFilterInput
  ) {
    onCreateAutorizaciones(filter: $filter) {
      id
      recibaSerialID
      recibaSerialMPID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      autoNumero
      serialRecibaBTI
      peticionTipo
      peticionModulo
      peticionMotivos
      peticionFecha
      peticionHora
      peticionUsuario
      peticionUAutorizar
      resolucion
      resolucionUsuario
      resolucionComentarios
      resolucionFecha
      resolucionHora
      cancelado
      cancelacionComentarios
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAutorizaciones = /* GraphQL */ `
  subscription OnUpdateAutorizaciones(
    $filter: ModelSubscriptionAutorizacionesFilterInput
  ) {
    onUpdateAutorizaciones(filter: $filter) {
      id
      recibaSerialID
      recibaSerialMPID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      autoNumero
      serialRecibaBTI
      peticionTipo
      peticionModulo
      peticionMotivos
      peticionFecha
      peticionHora
      peticionUsuario
      peticionUAutorizar
      resolucion
      resolucionUsuario
      resolucionComentarios
      resolucionFecha
      resolucionHora
      cancelado
      cancelacionComentarios
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAutorizaciones = /* GraphQL */ `
  subscription OnDeleteAutorizaciones(
    $filter: ModelSubscriptionAutorizacionesFilterInput
  ) {
    onDeleteAutorizaciones(filter: $filter) {
      id
      recibaSerialID
      recibaSerialMPID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      autoNumero
      serialRecibaBTI
      peticionTipo
      peticionModulo
      peticionMotivos
      peticionFecha
      peticionHora
      peticionUsuario
      peticionUAutorizar
      resolucion
      resolucionUsuario
      resolucionComentarios
      resolucionFecha
      resolucionHora
      cancelado
      cancelacionComentarios
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRecuperacion = /* GraphQL */ `
  subscription OnCreateRecuperacion(
    $filter: ModelSubscriptionRecuperacionFilterInput
  ) {
    onCreateRecuperacion(filter: $filter) {
      id
      recibaSerialID
      recibaSerialMPID
      pProduccionID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      cantidad
      cantidadLiberada
      piezasRecuperadas
      piezasNRecuperadas
      UbicacionDeIngreso
      LocacionDeIngreso
      ingresadoPorArea
      ingresadoPorUsuario
      mesaInspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentariosInspeccion
      comentariosRecuperacion
      ultimaInspeccion
      Revision1Inspector
      Revision1Comentarios
      Revision1CAprobado
      Revision1CALiberada
      Revision1CNAprobado
      Revision1CNALiberada
      Revision1MRecuperacion
      Revision2Inspector
      Revision2Comentarios
      Revision2CAprobado
      Revision2CALiberado
      Revision2CNAprobado
      Revision2CNALiberado
      Revision2MRecuperacion
      Revision3Inspector
      Revision3Comentarios
      Revision3CAprobado
      Revision3CALiberado
      Revision3CNAprobado
      Revision3CNALiberado
      Revision3MRecuperacion
      Revision4Inspector
      Revision4Comentarios
      Revision4CAprobado
      Revision4CALiberado
      Revision4CNAprobado
      Revision4CNALiberado
      Revision4MRecuperacion
      Revision5Inspector
      Revision5Comentarios
      Revision5CAprobado
      Revision5CALiberado
      Revision5CNAprobado
      Revision5CNALiberado
      Revision5MRecuperacion
      activo
      fechaIngreso
      horaIngreso
      fechaEntradaReal
      fechaEntrada
      horaEntrada
      ingresadoPor
      fechaSalida
      horaSalida
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRecuperacion = /* GraphQL */ `
  subscription OnUpdateRecuperacion(
    $filter: ModelSubscriptionRecuperacionFilterInput
  ) {
    onUpdateRecuperacion(filter: $filter) {
      id
      recibaSerialID
      recibaSerialMPID
      pProduccionID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      cantidad
      cantidadLiberada
      piezasRecuperadas
      piezasNRecuperadas
      UbicacionDeIngreso
      LocacionDeIngreso
      ingresadoPorArea
      ingresadoPorUsuario
      mesaInspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentariosInspeccion
      comentariosRecuperacion
      ultimaInspeccion
      Revision1Inspector
      Revision1Comentarios
      Revision1CAprobado
      Revision1CALiberada
      Revision1CNAprobado
      Revision1CNALiberada
      Revision1MRecuperacion
      Revision2Inspector
      Revision2Comentarios
      Revision2CAprobado
      Revision2CALiberado
      Revision2CNAprobado
      Revision2CNALiberado
      Revision2MRecuperacion
      Revision3Inspector
      Revision3Comentarios
      Revision3CAprobado
      Revision3CALiberado
      Revision3CNAprobado
      Revision3CNALiberado
      Revision3MRecuperacion
      Revision4Inspector
      Revision4Comentarios
      Revision4CAprobado
      Revision4CALiberado
      Revision4CNAprobado
      Revision4CNALiberado
      Revision4MRecuperacion
      Revision5Inspector
      Revision5Comentarios
      Revision5CAprobado
      Revision5CALiberado
      Revision5CNAprobado
      Revision5CNALiberado
      Revision5MRecuperacion
      activo
      fechaIngreso
      horaIngreso
      fechaEntradaReal
      fechaEntrada
      horaEntrada
      ingresadoPor
      fechaSalida
      horaSalida
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRecuperacion = /* GraphQL */ `
  subscription OnDeleteRecuperacion(
    $filter: ModelSubscriptionRecuperacionFilterInput
  ) {
    onDeleteRecuperacion(filter: $filter) {
      id
      recibaSerialID
      recibaSerialMPID
      pProduccionID
      clienteID
      cliente
      productoID
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      cantidad
      cantidadLiberada
      piezasRecuperadas
      piezasNRecuperadas
      UbicacionDeIngreso
      LocacionDeIngreso
      ingresadoPorArea
      ingresadoPorUsuario
      mesaInspeccion
      defecto
      otroDefecto
      mRecuperacion
      otroMRecuperacion
      comentariosInspeccion
      comentariosRecuperacion
      ultimaInspeccion
      Revision1Inspector
      Revision1Comentarios
      Revision1CAprobado
      Revision1CALiberada
      Revision1CNAprobado
      Revision1CNALiberada
      Revision1MRecuperacion
      Revision2Inspector
      Revision2Comentarios
      Revision2CAprobado
      Revision2CALiberado
      Revision2CNAprobado
      Revision2CNALiberado
      Revision2MRecuperacion
      Revision3Inspector
      Revision3Comentarios
      Revision3CAprobado
      Revision3CALiberado
      Revision3CNAprobado
      Revision3CNALiberado
      Revision3MRecuperacion
      Revision4Inspector
      Revision4Comentarios
      Revision4CAprobado
      Revision4CALiberado
      Revision4CNAprobado
      Revision4CNALiberado
      Revision4MRecuperacion
      Revision5Inspector
      Revision5Comentarios
      Revision5CAprobado
      Revision5CALiberado
      Revision5CNAprobado
      Revision5CNALiberado
      Revision5MRecuperacion
      activo
      fechaIngreso
      horaIngreso
      fechaEntradaReal
      fechaEntrada
      horaEntrada
      ingresadoPor
      fechaSalida
      horaSalida
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePlaneacionBase = /* GraphQL */ `
  subscription OnCreatePlaneacionBase(
    $filter: ModelSubscriptionPlaneacionBaseFilterInput
  ) {
    onCreatePlaneacionBase(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      planeacionGeneralID
      clienteID
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      cliente
      numerodeParte
      descripcion
      cantidadPiezas
      piezasXRack
      rackTipo
      prioridad
      prioridadAtencion
      racks
      ciclos
      materialEn
      materialEnCantidad
      orden
      activo
      comentarios
      comentariosProduccion
      fechaHoraCreacion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePlaneacionBase = /* GraphQL */ `
  subscription OnUpdatePlaneacionBase(
    $filter: ModelSubscriptionPlaneacionBaseFilterInput
  ) {
    onUpdatePlaneacionBase(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      planeacionGeneralID
      clienteID
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      cliente
      numerodeParte
      descripcion
      cantidadPiezas
      piezasXRack
      rackTipo
      prioridad
      prioridadAtencion
      racks
      ciclos
      materialEn
      materialEnCantidad
      orden
      activo
      comentarios
      comentariosProduccion
      fechaHoraCreacion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePlaneacionBase = /* GraphQL */ `
  subscription OnDeletePlaneacionBase(
    $filter: ModelSubscriptionPlaneacionBaseFilterInput
  ) {
    onDeletePlaneacionBase(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      planeacionGeneralID
      clienteID
      productoID
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      divisa
      cliente
      numerodeParte
      descripcion
      cantidadPiezas
      piezasXRack
      rackTipo
      prioridad
      prioridadAtencion
      racks
      ciclos
      materialEn
      materialEnCantidad
      orden
      activo
      comentarios
      comentariosProduccion
      fechaHoraCreacion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateADatosROperacion = /* GraphQL */ `
  subscription OnCreateADatosROperacion(
    $filter: ModelSubscriptionADatosROperacionFilterInput
  ) {
    onCreateADatosROperacion(filter: $filter) {
      id
      ecCapacidadLinea
      objetivoFacturacion
      metaVentaCumplimientoKPI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateADatosROperacion = /* GraphQL */ `
  subscription OnUpdateADatosROperacion(
    $filter: ModelSubscriptionADatosROperacionFilterInput
  ) {
    onUpdateADatosROperacion(filter: $filter) {
      id
      ecCapacidadLinea
      objetivoFacturacion
      metaVentaCumplimientoKPI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteADatosROperacion = /* GraphQL */ `
  subscription OnDeleteADatosROperacion(
    $filter: ModelSubscriptionADatosROperacionFilterInput
  ) {
    onDeleteADatosROperacion(filter: $filter) {
      id
      ecCapacidadLinea
      objetivoFacturacion
      metaVentaCumplimientoKPI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateResumenOperacion = /* GraphQL */ `
  subscription OnCreateResumenOperacion(
    $filter: ModelSubscriptionResumenOperacionFilterInput
  ) {
    onCreateResumenOperacion(filter: $filter) {
      id
      fecha
      totalInspeccionado
      recibaSerialIDS
      defectuso
      porcentajeDefectuoso
      primerContribuidor
      primerContribuidorNP
      segundoContribuidor
      segundoContribuidorNP
      tercerContribuidor
      tercerContribuidorNP
      sqftProducidos
      gastosQuimicos
      consumoAgua
      costoQuimicoSQFT
      costoQuimicovsFacturacion
      eficienciaCargaRacks
      ecCapacidadLinea
      ecProgramados
      ecCapacidadLineaProgramada
      ecCargados
      ecEFvsPP
      ecEspaciosVacios
      ecPorcentajePerdido
      apFaltaCarga
      apIncapacidadCarga
      apFaltaInspeccion
      apIncapacidadInspeccion
      apFaltaCargaPC
      apIncapacidadCargaPC
      apFaltaInspeccionPC
      apIncapacidadInspeccionPC
      objetivoFacturacion
      metaVentaCumplimientoKPI
      facturacionPlaneada
      facturacion
      facturadoPendientePorEmbarcar
      facturacionTotaldelDia
      diferenciaVSPlaneado
      diferenciaPorcentaje
      materialPendienteporInspeccion
      inventario
      estatusPendientesMejoras
      accionesaTomar
      inventarioOperacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateResumenOperacion = /* GraphQL */ `
  subscription OnUpdateResumenOperacion(
    $filter: ModelSubscriptionResumenOperacionFilterInput
  ) {
    onUpdateResumenOperacion(filter: $filter) {
      id
      fecha
      totalInspeccionado
      recibaSerialIDS
      defectuso
      porcentajeDefectuoso
      primerContribuidor
      primerContribuidorNP
      segundoContribuidor
      segundoContribuidorNP
      tercerContribuidor
      tercerContribuidorNP
      sqftProducidos
      gastosQuimicos
      consumoAgua
      costoQuimicoSQFT
      costoQuimicovsFacturacion
      eficienciaCargaRacks
      ecCapacidadLinea
      ecProgramados
      ecCapacidadLineaProgramada
      ecCargados
      ecEFvsPP
      ecEspaciosVacios
      ecPorcentajePerdido
      apFaltaCarga
      apIncapacidadCarga
      apFaltaInspeccion
      apIncapacidadInspeccion
      apFaltaCargaPC
      apIncapacidadCargaPC
      apFaltaInspeccionPC
      apIncapacidadInspeccionPC
      objetivoFacturacion
      metaVentaCumplimientoKPI
      facturacionPlaneada
      facturacion
      facturadoPendientePorEmbarcar
      facturacionTotaldelDia
      diferenciaVSPlaneado
      diferenciaPorcentaje
      materialPendienteporInspeccion
      inventario
      estatusPendientesMejoras
      accionesaTomar
      inventarioOperacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteResumenOperacion = /* GraphQL */ `
  subscription OnDeleteResumenOperacion(
    $filter: ModelSubscriptionResumenOperacionFilterInput
  ) {
    onDeleteResumenOperacion(filter: $filter) {
      id
      fecha
      totalInspeccionado
      recibaSerialIDS
      defectuso
      porcentajeDefectuoso
      primerContribuidor
      primerContribuidorNP
      segundoContribuidor
      segundoContribuidorNP
      tercerContribuidor
      tercerContribuidorNP
      sqftProducidos
      gastosQuimicos
      consumoAgua
      costoQuimicoSQFT
      costoQuimicovsFacturacion
      eficienciaCargaRacks
      ecCapacidadLinea
      ecProgramados
      ecCapacidadLineaProgramada
      ecCargados
      ecEFvsPP
      ecEspaciosVacios
      ecPorcentajePerdido
      apFaltaCarga
      apIncapacidadCarga
      apFaltaInspeccion
      apIncapacidadInspeccion
      apFaltaCargaPC
      apIncapacidadCargaPC
      apFaltaInspeccionPC
      apIncapacidadInspeccionPC
      objetivoFacturacion
      metaVentaCumplimientoKPI
      facturacionPlaneada
      facturacion
      facturadoPendientePorEmbarcar
      facturacionTotaldelDia
      diferenciaVSPlaneado
      diferenciaPorcentaje
      materialPendienteporInspeccion
      inventario
      estatusPendientesMejoras
      accionesaTomar
      inventarioOperacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePlaneacionBaseGeneral = /* GraphQL */ `
  subscription OnCreatePlaneacionBaseGeneral(
    $filter: ModelSubscriptionPlaneacionBaseGeneralFilterInput
  ) {
    onCreatePlaneacionBaseGeneral(filter: $filter) {
      id
      fechaDePlaneacion
      PlaneacionBIDS
      comentarios
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePlaneacionBaseGeneral = /* GraphQL */ `
  subscription OnUpdatePlaneacionBaseGeneral(
    $filter: ModelSubscriptionPlaneacionBaseGeneralFilterInput
  ) {
    onUpdatePlaneacionBaseGeneral(filter: $filter) {
      id
      fechaDePlaneacion
      PlaneacionBIDS
      comentarios
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePlaneacionBaseGeneral = /* GraphQL */ `
  subscription OnDeletePlaneacionBaseGeneral(
    $filter: ModelSubscriptionPlaneacionBaseGeneralFilterInput
  ) {
    onDeletePlaneacionBaseGeneral(filter: $filter) {
      id
      fechaDePlaneacion
      PlaneacionBIDS
      comentarios
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePlaneacion = /* GraphQL */ `
  subscription OnCreatePlaneacion(
    $filter: ModelSubscriptionPlaneacionFilterInput
  ) {
    onCreatePlaneacion(filter: $filter) {
      id
      fechaDePlaneacion
      numeroPProduccion
      numero
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      planeacionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      prioridad
      racks
      ciclos
      cantidadPlanProduccion
      enPlanProduccion
      materialEn
      materialEnCantidad
      orden
      activo
      atrasado
      terminado
      regresadoAlmacen
      piezasTransferidas
      FechaTransferencia
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePlaneacion = /* GraphQL */ `
  subscription OnUpdatePlaneacion(
    $filter: ModelSubscriptionPlaneacionFilterInput
  ) {
    onUpdatePlaneacion(filter: $filter) {
      id
      fechaDePlaneacion
      numeroPProduccion
      numero
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      planeacionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      prioridad
      racks
      ciclos
      cantidadPlanProduccion
      enPlanProduccion
      materialEn
      materialEnCantidad
      orden
      activo
      atrasado
      terminado
      regresadoAlmacen
      piezasTransferidas
      FechaTransferencia
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePlaneacion = /* GraphQL */ `
  subscription OnDeletePlaneacion(
    $filter: ModelSubscriptionPlaneacionFilterInput
  ) {
    onDeletePlaneacion(filter: $filter) {
      id
      fechaDePlaneacion
      numeroPProduccion
      numero
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      planeacionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      prioridad
      racks
      ciclos
      cantidadPlanProduccion
      enPlanProduccion
      materialEn
      materialEnCantidad
      orden
      activo
      atrasado
      terminado
      regresadoAlmacen
      piezasTransferidas
      FechaTransferencia
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePlaneacionGeneral = /* GraphQL */ `
  subscription OnCreatePlaneacionGeneral(
    $filter: ModelSubscriptionPlaneacionGeneralFilterInput
  ) {
    onCreatePlaneacionGeneral(filter: $filter) {
      id
      fechaDePlaneacion
      PlaneacionIDS
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePlaneacionGeneral = /* GraphQL */ `
  subscription OnUpdatePlaneacionGeneral(
    $filter: ModelSubscriptionPlaneacionGeneralFilterInput
  ) {
    onUpdatePlaneacionGeneral(filter: $filter) {
      id
      fechaDePlaneacion
      PlaneacionIDS
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePlaneacionGeneral = /* GraphQL */ `
  subscription OnDeletePlaneacionGeneral(
    $filter: ModelSubscriptionPlaneacionGeneralFilterInput
  ) {
    onDeletePlaneacionGeneral(filter: $filter) {
      id
      fechaDePlaneacion
      PlaneacionIDS
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePProduccion = /* GraphQL */ `
  subscription OnCreatePProduccion(
    $filter: ModelSubscriptionPProduccionFilterInput
  ) {
    onCreatePProduccion(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      numeroPlaneacion
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      PlaneacionID
      pproduccionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      piezasPintadas
      piezasTransferidas
      FechaTransferencia
      prioridad
      racks
      ciclos
      orden
      materialEn
      materialEnCantidad
      desdeAlmacen
      piezasenCarga
      piezasenPintado
      piezasInspeccion
      piezasCalidad
      piezasNoAceptadas
      pnadefecto
      pnaotroDefecto
      piezasIRecuperacion
      piezasCRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      MesasInspeccion
      racksOriginal
      numeroCarga
      ultimoRack
      cUnaInspeccion
      registroCarga
      registroPintado
      registroInspeccionF
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      piezasenCargaAnterior
      piezasenPintadoAnterior
      piezasInspeccionAnterior
      piezasNoAceptadasAnterior
      piezasenCarga1
      numeroRackCarga1
      racksCarga1
      cicloCarga1
      piezasenCarga2
      numeroRackCarga2
      racksCarga2
      cicloCarga2
      piezasenCarga3
      numeroRackCarga3
      racksCarga3
      cicloCarga3
      piezasenCarga4
      numeroRackCarga4
      racksCarga4
      cicloCarga4
      piezasenCarga5
      numeroRackCarga5
      racksCarga5
      cicloCarga5
      piezasenCarga6
      numeroRackCarga6
      racksCarga6
      cicloCarga6
      piezasenCarga7
      numeroRackCarga7
      racksCarga7
      cicloCarga7
      piezasenCarga8
      numeroRackCarga8
      racksCarga8
      cicloCarga8
      piezasenCarga9
      numeroRackCarga9
      racksCarga9
      cicloCarga9
      piezasenCarga10
      numeroRackCarga10
      racksCarga10
      cicloCarga10
      piezasenCarga11
      numeroRackCarga11
      racksCarga11
      cicloCarga11
      piezasenCarga12
      numeroRackCarga12
      racksCarga12
      cicloCarga12
      piezasenCarga13
      numeroRackCarga13
      racksCarga13
      cicloCarga13
      piezasenCarga14
      numeroRackCarga14
      racksCarga14
      cicloCarga14
      piezasenCarga15
      numeroRackCarga15
      racksCarga15
      cicloCarga15
      piezasenCarga16
      numeroRackCarga16
      racksCarga16
      cicloCarga16
      activo
      terminado
      regresadoAlmacen
      atrasado
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePProduccion = /* GraphQL */ `
  subscription OnUpdatePProduccion(
    $filter: ModelSubscriptionPProduccionFilterInput
  ) {
    onUpdatePProduccion(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      numeroPlaneacion
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      PlaneacionID
      pproduccionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      piezasPintadas
      piezasTransferidas
      FechaTransferencia
      prioridad
      racks
      ciclos
      orden
      materialEn
      materialEnCantidad
      desdeAlmacen
      piezasenCarga
      piezasenPintado
      piezasInspeccion
      piezasCalidad
      piezasNoAceptadas
      pnadefecto
      pnaotroDefecto
      piezasIRecuperacion
      piezasCRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      MesasInspeccion
      racksOriginal
      numeroCarga
      ultimoRack
      cUnaInspeccion
      registroCarga
      registroPintado
      registroInspeccionF
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      piezasenCargaAnterior
      piezasenPintadoAnterior
      piezasInspeccionAnterior
      piezasNoAceptadasAnterior
      piezasenCarga1
      numeroRackCarga1
      racksCarga1
      cicloCarga1
      piezasenCarga2
      numeroRackCarga2
      racksCarga2
      cicloCarga2
      piezasenCarga3
      numeroRackCarga3
      racksCarga3
      cicloCarga3
      piezasenCarga4
      numeroRackCarga4
      racksCarga4
      cicloCarga4
      piezasenCarga5
      numeroRackCarga5
      racksCarga5
      cicloCarga5
      piezasenCarga6
      numeroRackCarga6
      racksCarga6
      cicloCarga6
      piezasenCarga7
      numeroRackCarga7
      racksCarga7
      cicloCarga7
      piezasenCarga8
      numeroRackCarga8
      racksCarga8
      cicloCarga8
      piezasenCarga9
      numeroRackCarga9
      racksCarga9
      cicloCarga9
      piezasenCarga10
      numeroRackCarga10
      racksCarga10
      cicloCarga10
      piezasenCarga11
      numeroRackCarga11
      racksCarga11
      cicloCarga11
      piezasenCarga12
      numeroRackCarga12
      racksCarga12
      cicloCarga12
      piezasenCarga13
      numeroRackCarga13
      racksCarga13
      cicloCarga13
      piezasenCarga14
      numeroRackCarga14
      racksCarga14
      cicloCarga14
      piezasenCarga15
      numeroRackCarga15
      racksCarga15
      cicloCarga15
      piezasenCarga16
      numeroRackCarga16
      racksCarga16
      cicloCarga16
      activo
      terminado
      regresadoAlmacen
      atrasado
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePProduccion = /* GraphQL */ `
  subscription OnDeletePProduccion(
    $filter: ModelSubscriptionPProduccionFilterInput
  ) {
    onDeletePProduccion(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      numeroPlaneacion
      recibaSerialID
      recibaSerialMPID
      sporNP
      krecibaNP
      PlaneacionID
      pproduccionGeneralID
      clienteID
      productoID
      precioUnitario
      divisa
      cliente
      numerodeParte
      descripcion
      serial
      serialRecibaBTI
      locacion
      cantidadPiezas
      piezasXRack
      piezasPintadas
      piezasTransferidas
      FechaTransferencia
      prioridad
      racks
      ciclos
      orden
      materialEn
      materialEnCantidad
      desdeAlmacen
      piezasenCarga
      piezasenPintado
      piezasInspeccion
      piezasCalidad
      piezasNoAceptadas
      pnadefecto
      pnaotroDefecto
      piezasIRecuperacion
      piezasCRecuperacion
      piezasTRecuperacion
      piezasRecuperadas
      piezasNRecuperadas
      MesasInspeccion
      racksOriginal
      numeroCarga
      ultimoRack
      cUnaInspeccion
      registroCarga
      registroPintado
      registroInspeccionF
      cargaFechaHora
      pintadoFechaHora
      inspeccionesFechaHora
      recuperacionICFechaHora
      calidadFechaHora
      noAceptadasFechaHora
      piezasenCargaAnterior
      piezasenPintadoAnterior
      piezasInspeccionAnterior
      piezasNoAceptadasAnterior
      piezasenCarga1
      numeroRackCarga1
      racksCarga1
      cicloCarga1
      piezasenCarga2
      numeroRackCarga2
      racksCarga2
      cicloCarga2
      piezasenCarga3
      numeroRackCarga3
      racksCarga3
      cicloCarga3
      piezasenCarga4
      numeroRackCarga4
      racksCarga4
      cicloCarga4
      piezasenCarga5
      numeroRackCarga5
      racksCarga5
      cicloCarga5
      piezasenCarga6
      numeroRackCarga6
      racksCarga6
      cicloCarga6
      piezasenCarga7
      numeroRackCarga7
      racksCarga7
      cicloCarga7
      piezasenCarga8
      numeroRackCarga8
      racksCarga8
      cicloCarga8
      piezasenCarga9
      numeroRackCarga9
      racksCarga9
      cicloCarga9
      piezasenCarga10
      numeroRackCarga10
      racksCarga10
      cicloCarga10
      piezasenCarga11
      numeroRackCarga11
      racksCarga11
      cicloCarga11
      piezasenCarga12
      numeroRackCarga12
      racksCarga12
      cicloCarga12
      piezasenCarga13
      numeroRackCarga13
      racksCarga13
      cicloCarga13
      piezasenCarga14
      numeroRackCarga14
      racksCarga14
      cicloCarga14
      piezasenCarga15
      numeroRackCarga15
      racksCarga15
      cicloCarga15
      piezasenCarga16
      numeroRackCarga16
      racksCarga16
      cicloCarga16
      activo
      terminado
      regresadoAlmacen
      atrasado
      fechaAnterior
      planeacionIDAnterior
      pProduccionIDAnterior
      fechaHoraCreacion
      desdePproduccion
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePProduccionGeneral = /* GraphQL */ `
  subscription OnCreatePProduccionGeneral(
    $filter: ModelSubscriptionPProduccionGeneralFilterInput
  ) {
    onCreatePProduccionGeneral(filter: $filter) {
      id
      fechaDePlaneacion
      PProduccionIDS
      recibaSerialIDS
      porSerial
      numero
      espacioVacio
      espacioHora
      espacioHistorial
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePProduccionGeneral = /* GraphQL */ `
  subscription OnUpdatePProduccionGeneral(
    $filter: ModelSubscriptionPProduccionGeneralFilterInput
  ) {
    onUpdatePProduccionGeneral(filter: $filter) {
      id
      fechaDePlaneacion
      PProduccionIDS
      recibaSerialIDS
      porSerial
      numero
      espacioVacio
      espacioHora
      espacioHistorial
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePProduccionGeneral = /* GraphQL */ `
  subscription OnDeletePProduccionGeneral(
    $filter: ModelSubscriptionPProduccionGeneralFilterInput
  ) {
    onDeletePProduccionGeneral(filter: $filter) {
      id
      fechaDePlaneacion
      PProduccionIDS
      recibaSerialIDS
      porSerial
      numero
      espacioVacio
      espacioHora
      espacioHistorial
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateEmbarque = /* GraphQL */ `
  subscription OnCreateEmbarque($filter: ModelSubscriptionEmbarqueFilterInput) {
    onCreateEmbarque(filter: $filter) {
      id
      fechaDeEmbarque
      fechaDeReciba
      serialesEID
      MFGFecha
      numero
      invoiceID
      atencionA
      ordenDeCompra
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      numerosdeParte
      totalNumerodeParte
      sinTotalScrap
      sinTotalScrapFactura
      packings
      lotes
      seriales
      piezasEmbarcadas
      piezasPintadas
      piezasPintadasExtra
      piezasNRecuperadas
      piezasNoPintadas
      facturado
      facturaDescuentoP
      fechaDeFacturacion
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      comentariosFacturacion
      serviciosExtra
      servicioExtraEmbarques
      desgloceVer
      desgloceVerFacturacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateEmbarque = /* GraphQL */ `
  subscription OnUpdateEmbarque($filter: ModelSubscriptionEmbarqueFilterInput) {
    onUpdateEmbarque(filter: $filter) {
      id
      fechaDeEmbarque
      fechaDeReciba
      serialesEID
      MFGFecha
      numero
      invoiceID
      atencionA
      ordenDeCompra
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      numerosdeParte
      totalNumerodeParte
      sinTotalScrap
      sinTotalScrapFactura
      packings
      lotes
      seriales
      piezasEmbarcadas
      piezasPintadas
      piezasPintadasExtra
      piezasNRecuperadas
      piezasNoPintadas
      facturado
      facturaDescuentoP
      fechaDeFacturacion
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      comentariosFacturacion
      serviciosExtra
      servicioExtraEmbarques
      desgloceVer
      desgloceVerFacturacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteEmbarque = /* GraphQL */ `
  subscription OnDeleteEmbarque($filter: ModelSubscriptionEmbarqueFilterInput) {
    onDeleteEmbarque(filter: $filter) {
      id
      fechaDeEmbarque
      fechaDeReciba
      serialesEID
      MFGFecha
      numero
      invoiceID
      atencionA
      ordenDeCompra
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      numerosdeParte
      totalNumerodeParte
      sinTotalScrap
      sinTotalScrapFactura
      packings
      lotes
      seriales
      piezasEmbarcadas
      piezasPintadas
      piezasPintadasExtra
      piezasNRecuperadas
      piezasNoPintadas
      facturado
      facturaDescuentoP
      fechaDeFacturacion
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      comentariosFacturacion
      serviciosExtra
      servicioExtraEmbarques
      desgloceVer
      desgloceVerFacturacion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateFacturaConceptoGeneral = /* GraphQL */ `
  subscription OnCreateFacturaConceptoGeneral(
    $filter: ModelSubscriptionFacturaConceptoGeneralFilterInput
  ) {
    onCreateFacturaConceptoGeneral(filter: $filter) {
      id
      fechaDeFacturacion
      numero
      invoiceID
      clienteID
      cliente
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      facturaDescuentoP
      comentariosFacturacion
      Conceptos
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateFacturaConceptoGeneral = /* GraphQL */ `
  subscription OnUpdateFacturaConceptoGeneral(
    $filter: ModelSubscriptionFacturaConceptoGeneralFilterInput
  ) {
    onUpdateFacturaConceptoGeneral(filter: $filter) {
      id
      fechaDeFacturacion
      numero
      invoiceID
      clienteID
      cliente
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      facturaDescuentoP
      comentariosFacturacion
      Conceptos
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteFacturaConceptoGeneral = /* GraphQL */ `
  subscription OnDeleteFacturaConceptoGeneral(
    $filter: ModelSubscriptionFacturaConceptoGeneralFilterInput
  ) {
    onDeleteFacturaConceptoGeneral(filter: $filter) {
      id
      fechaDeFacturacion
      numero
      invoiceID
      clienteID
      cliente
      billTo
      shipTo
      salesPerson
      PO
      requisitioner
      shippedvia
      dueDate
      casQuote
      facturaDescuentoP
      comentariosFacturacion
      Conceptos
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateEmbarqueSeriales = /* GraphQL */ `
  subscription OnCreateEmbarqueSeriales(
    $filter: ModelSubscriptionEmbarqueSerialesFilterInput
  ) {
    onCreateEmbarqueSeriales(filter: $filter) {
      id
      embarqueID
      numero
      invoiceID
      numeroSerial
      fechaDeEmbarque
      fechaDeReciba
      MFGFecha
      atencionA
      ordenDeCompra
      comentarios
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      facturado
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      precioUnitarioTot
      divisa
      recibaSerialID
      recibaSerialMPID
      productoID
      numerodeParte
      numerodeParteSalida
      poEmbarques
      descripcion
      desgloceInsercion
      piezasPintadasExtra
      piezasPintadas
      piezasEmbarcadas
      piezasCtnaNRecuperadas
      piezasNoPintadas
      piezasNRecuperadas
      piezasNRecuperadasE
      pNRecuperadasOriginal
      pPintadasOriginal
      packing
      lote
      po
      MaterialPintado
      ambos
      serial
      serialRecibaBTI
      serialNRecuperado
      materialEn
      materialEnCantidad
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateEmbarqueSeriales = /* GraphQL */ `
  subscription OnUpdateEmbarqueSeriales(
    $filter: ModelSubscriptionEmbarqueSerialesFilterInput
  ) {
    onUpdateEmbarqueSeriales(filter: $filter) {
      id
      embarqueID
      numero
      invoiceID
      numeroSerial
      fechaDeEmbarque
      fechaDeReciba
      MFGFecha
      atencionA
      ordenDeCompra
      comentarios
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      facturado
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      precioUnitarioTot
      divisa
      recibaSerialID
      recibaSerialMPID
      productoID
      numerodeParte
      numerodeParteSalida
      poEmbarques
      descripcion
      desgloceInsercion
      piezasPintadasExtra
      piezasPintadas
      piezasEmbarcadas
      piezasCtnaNRecuperadas
      piezasNoPintadas
      piezasNRecuperadas
      piezasNRecuperadasE
      pNRecuperadasOriginal
      pPintadasOriginal
      packing
      lote
      po
      MaterialPintado
      ambos
      serial
      serialRecibaBTI
      serialNRecuperado
      materialEn
      materialEnCantidad
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteEmbarqueSeriales = /* GraphQL */ `
  subscription OnDeleteEmbarqueSeriales(
    $filter: ModelSubscriptionEmbarqueSerialesFilterInput
  ) {
    onDeleteEmbarqueSeriales(filter: $filter) {
      id
      embarqueID
      numero
      invoiceID
      numeroSerial
      fechaDeEmbarque
      fechaDeReciba
      MFGFecha
      atencionA
      ordenDeCompra
      comentarios
      clienteID
      cliente
      clienteEntregaID
      clienteEntrega
      facturarA
      facturado
      Pcoat
      Ecoat
      Platinado
      precioUnitario
      precioUnitarioP
      precioUnitarioPC
      precioUnitarioTot
      divisa
      recibaSerialID
      recibaSerialMPID
      productoID
      numerodeParte
      numerodeParteSalida
      poEmbarques
      descripcion
      desgloceInsercion
      piezasPintadasExtra
      piezasPintadas
      piezasEmbarcadas
      piezasCtnaNRecuperadas
      piezasNoPintadas
      piezasNRecuperadas
      piezasNRecuperadasE
      pNRecuperadasOriginal
      pPintadasOriginal
      packing
      lote
      po
      MaterialPintado
      ambos
      serial
      serialRecibaBTI
      serialNRecuperado
      materialEn
      materialEnCantidad
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCotizacion = /* GraphQL */ `
  subscription OnCreateCotizacion(
    $filter: ModelSubscriptionCotizacionFilterInput
  ) {
    onCreateCotizacion(filter: $filter) {
      id
      CotizacionPadreID
      numero
      quoteNumber
      divisa
      date
      status
      fechaCreado
      fechaAutorizado
      fechaEnviado
      fechaEsperando
      fechaAceptado
      fechaRechazado
      generator
      revision
      processEngineering
      platingProcess
      clienteID
      cliente
      clienteCatalogo
      clienteNContacto
      productoCreado
      productoID
      address
      colonia
      ciudad
      estado
      pais
      codigoPostal
      telefono
      correo
      requestor
      position
      desk
      mobile
      email
      automotive
      OEM
      RFQNumber
      numerodeParte
      descripcion
      nickName
      annualVolume
      packigType
      packingINumber
      packingIRevision
      packingSource
      sampleReceived
      drawingSProvided
      drawingRevision
      paintThickness
      paintSpec
      zincPlating
      chromateColor
      previousProcess
      whiteCRequirement
      RedCRequiremen
      SOP
      EOP
      area
      pieceWeight
      printNotes
      salesNotes
      hangingTool
      asignedToolBar
      rackType
      piecesperBar
      barsPerLevel
      levels
      piecesPerRack
      weightForRack
      totalPerRack
      toolingCost
      maximumPieces
      newToolRequired
      costOfNewTool
      totalWeightRack
      asignedVoltage
      suggestedRack
      processSuggestedPrice
      finalRackSale
      finalSalePrice
      finalSQFTPrice
      typeOfProcess
      hangingToolP
      firstRowDistance
      tPiecesPROB
      pPerlevel
      lPerRack
      toolAngle
      toolingCostP
      SQTFPerBR
      loadWeightK
      DCVoltageA
      DCAmperageA
      residenceTimeZinc
      residenceTimeChromate
      suggestedRBSale
      finalRBSale
      processPSuggestedPrice
      finalPSalePrice
      SQFTPPrice
      finalPSQFTPrice
      PPAPLevel
      aPPAPSubmission
      aSpecRessumission
      exsistingFamilly
      pointsToQuality
      qualityNotes
      costoPintura
      autorizado
      documentoAceptacion
      comentariosDeRechazo
      image
      documento1
      documento2
      documento3
      documento4
      documento5
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCotizacion = /* GraphQL */ `
  subscription OnUpdateCotizacion(
    $filter: ModelSubscriptionCotizacionFilterInput
  ) {
    onUpdateCotizacion(filter: $filter) {
      id
      CotizacionPadreID
      numero
      quoteNumber
      divisa
      date
      status
      fechaCreado
      fechaAutorizado
      fechaEnviado
      fechaEsperando
      fechaAceptado
      fechaRechazado
      generator
      revision
      processEngineering
      platingProcess
      clienteID
      cliente
      clienteCatalogo
      clienteNContacto
      productoCreado
      productoID
      address
      colonia
      ciudad
      estado
      pais
      codigoPostal
      telefono
      correo
      requestor
      position
      desk
      mobile
      email
      automotive
      OEM
      RFQNumber
      numerodeParte
      descripcion
      nickName
      annualVolume
      packigType
      packingINumber
      packingIRevision
      packingSource
      sampleReceived
      drawingSProvided
      drawingRevision
      paintThickness
      paintSpec
      zincPlating
      chromateColor
      previousProcess
      whiteCRequirement
      RedCRequiremen
      SOP
      EOP
      area
      pieceWeight
      printNotes
      salesNotes
      hangingTool
      asignedToolBar
      rackType
      piecesperBar
      barsPerLevel
      levels
      piecesPerRack
      weightForRack
      totalPerRack
      toolingCost
      maximumPieces
      newToolRequired
      costOfNewTool
      totalWeightRack
      asignedVoltage
      suggestedRack
      processSuggestedPrice
      finalRackSale
      finalSalePrice
      finalSQFTPrice
      typeOfProcess
      hangingToolP
      firstRowDistance
      tPiecesPROB
      pPerlevel
      lPerRack
      toolAngle
      toolingCostP
      SQTFPerBR
      loadWeightK
      DCVoltageA
      DCAmperageA
      residenceTimeZinc
      residenceTimeChromate
      suggestedRBSale
      finalRBSale
      processPSuggestedPrice
      finalPSalePrice
      SQFTPPrice
      finalPSQFTPrice
      PPAPLevel
      aPPAPSubmission
      aSpecRessumission
      exsistingFamilly
      pointsToQuality
      qualityNotes
      costoPintura
      autorizado
      documentoAceptacion
      comentariosDeRechazo
      image
      documento1
      documento2
      documento3
      documento4
      documento5
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCotizacion = /* GraphQL */ `
  subscription OnDeleteCotizacion(
    $filter: ModelSubscriptionCotizacionFilterInput
  ) {
    onDeleteCotizacion(filter: $filter) {
      id
      CotizacionPadreID
      numero
      quoteNumber
      divisa
      date
      status
      fechaCreado
      fechaAutorizado
      fechaEnviado
      fechaEsperando
      fechaAceptado
      fechaRechazado
      generator
      revision
      processEngineering
      platingProcess
      clienteID
      cliente
      clienteCatalogo
      clienteNContacto
      productoCreado
      productoID
      address
      colonia
      ciudad
      estado
      pais
      codigoPostal
      telefono
      correo
      requestor
      position
      desk
      mobile
      email
      automotive
      OEM
      RFQNumber
      numerodeParte
      descripcion
      nickName
      annualVolume
      packigType
      packingINumber
      packingIRevision
      packingSource
      sampleReceived
      drawingSProvided
      drawingRevision
      paintThickness
      paintSpec
      zincPlating
      chromateColor
      previousProcess
      whiteCRequirement
      RedCRequiremen
      SOP
      EOP
      area
      pieceWeight
      printNotes
      salesNotes
      hangingTool
      asignedToolBar
      rackType
      piecesperBar
      barsPerLevel
      levels
      piecesPerRack
      weightForRack
      totalPerRack
      toolingCost
      maximumPieces
      newToolRequired
      costOfNewTool
      totalWeightRack
      asignedVoltage
      suggestedRack
      processSuggestedPrice
      finalRackSale
      finalSalePrice
      finalSQFTPrice
      typeOfProcess
      hangingToolP
      firstRowDistance
      tPiecesPROB
      pPerlevel
      lPerRack
      toolAngle
      toolingCostP
      SQTFPerBR
      loadWeightK
      DCVoltageA
      DCAmperageA
      residenceTimeZinc
      residenceTimeChromate
      suggestedRBSale
      finalRBSale
      processPSuggestedPrice
      finalPSalePrice
      SQFTPPrice
      finalPSQFTPrice
      PPAPLevel
      aPPAPSubmission
      aSpecRessumission
      exsistingFamilly
      pointsToQuality
      qualityNotes
      costoPintura
      autorizado
      documentoAceptacion
      comentariosDeRechazo
      image
      documento1
      documento2
      documento3
      documento4
      documento5
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCotizacionArea = /* GraphQL */ `
  subscription OnCreateCotizacionArea(
    $filter: ModelSubscriptionCotizacionAreaFilterInput
  ) {
    onCreateCotizacionArea(filter: $filter) {
      id
      numero
      idCotizacion
      medidaIngresadaEn
      alto
      ancho
      repeticiones
      orden
      medidaGrosor
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCotizacionArea = /* GraphQL */ `
  subscription OnUpdateCotizacionArea(
    $filter: ModelSubscriptionCotizacionAreaFilterInput
  ) {
    onUpdateCotizacionArea(filter: $filter) {
      id
      numero
      idCotizacion
      medidaIngresadaEn
      alto
      ancho
      repeticiones
      orden
      medidaGrosor
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCotizacionArea = /* GraphQL */ `
  subscription OnDeleteCotizacionArea(
    $filter: ModelSubscriptionCotizacionAreaFilterInput
  ) {
    onDeleteCotizacionArea(filter: $filter) {
      id
      numero
      idCotizacion
      medidaIngresadaEn
      alto
      ancho
      repeticiones
      orden
      medidaGrosor
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateEmbarqueUltimoNumero = /* GraphQL */ `
  subscription OnCreateEmbarqueUltimoNumero(
    $filter: ModelSubscriptionEmbarqueUltimoNumeroFilterInput
  ) {
    onCreateEmbarqueUltimoNumero(filter: $filter) {
      id
      numero
      numeroRobetS
      UltimoNumeroSerial
      numeroFacturaGeneral
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateEmbarqueUltimoNumero = /* GraphQL */ `
  subscription OnUpdateEmbarqueUltimoNumero(
    $filter: ModelSubscriptionEmbarqueUltimoNumeroFilterInput
  ) {
    onUpdateEmbarqueUltimoNumero(filter: $filter) {
      id
      numero
      numeroRobetS
      UltimoNumeroSerial
      numeroFacturaGeneral
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteEmbarqueUltimoNumero = /* GraphQL */ `
  subscription OnDeleteEmbarqueUltimoNumero(
    $filter: ModelSubscriptionEmbarqueUltimoNumeroFilterInput
  ) {
    onDeleteEmbarqueUltimoNumero(filter: $filter) {
      id
      numero
      numeroRobetS
      UltimoNumeroSerial
      numeroFacturaGeneral
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePProduccionUltimoNumero = /* GraphQL */ `
  subscription OnCreatePProduccionUltimoNumero(
    $filter: ModelSubscriptionPProduccionUltimoNumeroFilterInput
  ) {
    onCreatePProduccionUltimoNumero(filter: $filter) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePProduccionUltimoNumero = /* GraphQL */ `
  subscription OnUpdatePProduccionUltimoNumero(
    $filter: ModelSubscriptionPProduccionUltimoNumeroFilterInput
  ) {
    onUpdatePProduccionUltimoNumero(filter: $filter) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePProduccionUltimoNumero = /* GraphQL */ `
  subscription OnDeletePProduccionUltimoNumero(
    $filter: ModelSubscriptionPProduccionUltimoNumeroFilterInput
  ) {
    onDeletePProduccionUltimoNumero(filter: $filter) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePlaneacionBaseUltimoNumero = /* GraphQL */ `
  subscription OnCreatePlaneacionBaseUltimoNumero(
    $filter: ModelSubscriptionPlaneacionBaseUltimoNumeroFilterInput
  ) {
    onCreatePlaneacionBaseUltimoNumero(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePlaneacionBaseUltimoNumero = /* GraphQL */ `
  subscription OnUpdatePlaneacionBaseUltimoNumero(
    $filter: ModelSubscriptionPlaneacionBaseUltimoNumeroFilterInput
  ) {
    onUpdatePlaneacionBaseUltimoNumero(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePlaneacionBaseUltimoNumero = /* GraphQL */ `
  subscription OnDeletePlaneacionBaseUltimoNumero(
    $filter: ModelSubscriptionPlaneacionBaseUltimoNumeroFilterInput
  ) {
    onDeletePlaneacionBaseUltimoNumero(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreatePlaneacionUltimoNumero = /* GraphQL */ `
  subscription OnCreatePlaneacionUltimoNumero(
    $filter: ModelSubscriptionPlaneacionUltimoNumeroFilterInput
  ) {
    onCreatePlaneacionUltimoNumero(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      horasProduccion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePlaneacionUltimoNumero = /* GraphQL */ `
  subscription OnUpdatePlaneacionUltimoNumero(
    $filter: ModelSubscriptionPlaneacionUltimoNumeroFilterInput
  ) {
    onUpdatePlaneacionUltimoNumero(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      horasProduccion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeletePlaneacionUltimoNumero = /* GraphQL */ `
  subscription OnDeletePlaneacionUltimoNumero(
    $filter: ModelSubscriptionPlaneacionUltimoNumeroFilterInput
  ) {
    onDeletePlaneacionUltimoNumero(filter: $filter) {
      id
      fechaDePlaneacion
      numero
      horasProduccion
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateRecibaUltimoNumero = /* GraphQL */ `
  subscription OnCreateRecibaUltimoNumero(
    $filter: ModelSubscriptionRecibaUltimoNumeroFilterInput
  ) {
    onCreateRecibaUltimoNumero(filter: $filter) {
      id
      numero
      serialRecibaBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateRecibaUltimoNumero = /* GraphQL */ `
  subscription OnUpdateRecibaUltimoNumero(
    $filter: ModelSubscriptionRecibaUltimoNumeroFilterInput
  ) {
    onUpdateRecibaUltimoNumero(filter: $filter) {
      id
      numero
      serialRecibaBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteRecibaUltimoNumero = /* GraphQL */ `
  subscription OnDeleteRecibaUltimoNumero(
    $filter: ModelSubscriptionRecibaUltimoNumeroFilterInput
  ) {
    onDeleteRecibaUltimoNumero(filter: $filter) {
      id
      numero
      serialRecibaBTI
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCotizacionUltimoNumero = /* GraphQL */ `
  subscription OnCreateCotizacionUltimoNumero(
    $filter: ModelSubscriptionCotizacionUltimoNumeroFilterInput
  ) {
    onCreateCotizacionUltimoNumero(filter: $filter) {
      id
      fecha
      numero
      quoteNumber
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCotizacionUltimoNumero = /* GraphQL */ `
  subscription OnUpdateCotizacionUltimoNumero(
    $filter: ModelSubscriptionCotizacionUltimoNumeroFilterInput
  ) {
    onUpdateCotizacionUltimoNumero(filter: $filter) {
      id
      fecha
      numero
      quoteNumber
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCotizacionUltimoNumero = /* GraphQL */ `
  subscription OnDeleteCotizacionUltimoNumero(
    $filter: ModelSubscriptionCotizacionUltimoNumeroFilterInput
  ) {
    onDeleteCotizacionUltimoNumero(filter: $filter) {
      id
      fecha
      numero
      quoteNumber
      costoPintura
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateTicketUltimoNumero = /* GraphQL */ `
  subscription OnCreateTicketUltimoNumero(
    $filter: ModelSubscriptionTicketUltimoNumeroFilterInput
  ) {
    onCreateTicketUltimoNumero(filter: $filter) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateTicketUltimoNumero = /* GraphQL */ `
  subscription OnUpdateTicketUltimoNumero(
    $filter: ModelSubscriptionTicketUltimoNumeroFilterInput
  ) {
    onUpdateTicketUltimoNumero(filter: $filter) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteTicketUltimoNumero = /* GraphQL */ `
  subscription OnDeleteTicketUltimoNumero(
    $filter: ModelSubscriptionTicketUltimoNumeroFilterInput
  ) {
    onDeleteTicketUltimoNumero(filter: $filter) {
      id
      numero
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateUsuarios = /* GraphQL */ `
  subscription OnCreateUsuarios($filter: ModelSubscriptionUsuariosFilterInput) {
    onCreateUsuarios(filter: $filter) {
      id
      usuario
      nombreCompleto
      correo
      Almacen
      AlmacenDInventario
      Administrar
      Cotizaciones
      CotizacionesAutorizar
      Cuarentena
      Incoming
      IncomingDescarga
      Clientes
      Planeacion
      verPlaneacion
      verPlaneacionBase
      AgregarComentariosPPB
      Productos
      Reciba
      ModificarCantidadR
      RecibaDescargar
      PProduccion
      Produccion
      ProduccionInspeccion
      ProduccionCalidad
      ProduccionRecuperacion
      ProduccionCargaManual
      ModificarCantidadesAR
      PlaneacionSinFIFO
      PlaneacionAutNoFIFO
      PProduccionAutNoFIFO1
      PProduccionAutNoFIFO2
      InspeccionUnicaCalidad
      AutorizarTodo
      AutorizarCalidad
      AutorizarEmbarques
      ResumenOperacionVer
      ResumenOperacionEDefectos
      ResumenOperacionEPLaboratorio
      ResumenOperacionEAusentismoP
      ResumenOperacionEDatosExtra
      ProduccionReporteSema
      verPlanProduccion
      Embarques
      verEmbarques
      EmbarquesDInventario
      Ubicacion
      Facturacion
      Metricas
      MarcarFueradePlanta
      MarcarEmbarcadoAlmacen
      MarcarEmbarcadoEmbarques
      PaginaInicial
      AgregarProvedores
      AutorizarProvedores
      Compras
      LevantarRequisicion
      AutorizarRequisicion
      AutorizarCompra
      VerPrecioUnitario
      GestionarUbicacion
      TicketsUsuarios
      TicketsSoporte
      TicketsAuditor
      Notificaciones
      Usuarios
      perfil
      image
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUsuarios = /* GraphQL */ `
  subscription OnUpdateUsuarios($filter: ModelSubscriptionUsuariosFilterInput) {
    onUpdateUsuarios(filter: $filter) {
      id
      usuario
      nombreCompleto
      correo
      Almacen
      AlmacenDInventario
      Administrar
      Cotizaciones
      CotizacionesAutorizar
      Cuarentena
      Incoming
      IncomingDescarga
      Clientes
      Planeacion
      verPlaneacion
      verPlaneacionBase
      AgregarComentariosPPB
      Productos
      Reciba
      ModificarCantidadR
      RecibaDescargar
      PProduccion
      Produccion
      ProduccionInspeccion
      ProduccionCalidad
      ProduccionRecuperacion
      ProduccionCargaManual
      ModificarCantidadesAR
      PlaneacionSinFIFO
      PlaneacionAutNoFIFO
      PProduccionAutNoFIFO1
      PProduccionAutNoFIFO2
      InspeccionUnicaCalidad
      AutorizarTodo
      AutorizarCalidad
      AutorizarEmbarques
      ResumenOperacionVer
      ResumenOperacionEDefectos
      ResumenOperacionEPLaboratorio
      ResumenOperacionEAusentismoP
      ResumenOperacionEDatosExtra
      ProduccionReporteSema
      verPlanProduccion
      Embarques
      verEmbarques
      EmbarquesDInventario
      Ubicacion
      Facturacion
      Metricas
      MarcarFueradePlanta
      MarcarEmbarcadoAlmacen
      MarcarEmbarcadoEmbarques
      PaginaInicial
      AgregarProvedores
      AutorizarProvedores
      Compras
      LevantarRequisicion
      AutorizarRequisicion
      AutorizarCompra
      VerPrecioUnitario
      GestionarUbicacion
      TicketsUsuarios
      TicketsSoporte
      TicketsAuditor
      Notificaciones
      Usuarios
      perfil
      image
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUsuarios = /* GraphQL */ `
  subscription OnDeleteUsuarios($filter: ModelSubscriptionUsuariosFilterInput) {
    onDeleteUsuarios(filter: $filter) {
      id
      usuario
      nombreCompleto
      correo
      Almacen
      AlmacenDInventario
      Administrar
      Cotizaciones
      CotizacionesAutorizar
      Cuarentena
      Incoming
      IncomingDescarga
      Clientes
      Planeacion
      verPlaneacion
      verPlaneacionBase
      AgregarComentariosPPB
      Productos
      Reciba
      ModificarCantidadR
      RecibaDescargar
      PProduccion
      Produccion
      ProduccionInspeccion
      ProduccionCalidad
      ProduccionRecuperacion
      ProduccionCargaManual
      ModificarCantidadesAR
      PlaneacionSinFIFO
      PlaneacionAutNoFIFO
      PProduccionAutNoFIFO1
      PProduccionAutNoFIFO2
      InspeccionUnicaCalidad
      AutorizarTodo
      AutorizarCalidad
      AutorizarEmbarques
      ResumenOperacionVer
      ResumenOperacionEDefectos
      ResumenOperacionEPLaboratorio
      ResumenOperacionEAusentismoP
      ResumenOperacionEDatosExtra
      ProduccionReporteSema
      verPlanProduccion
      Embarques
      verEmbarques
      EmbarquesDInventario
      Ubicacion
      Facturacion
      Metricas
      MarcarFueradePlanta
      MarcarEmbarcadoAlmacen
      MarcarEmbarcadoEmbarques
      PaginaInicial
      AgregarProvedores
      AutorizarProvedores
      Compras
      LevantarRequisicion
      AutorizarRequisicion
      AutorizarCompra
      VerPrecioUnitario
      GestionarUbicacion
      TicketsUsuarios
      TicketsSoporte
      TicketsAuditor
      Notificaciones
      Usuarios
      perfil
      image
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateLocacion = /* GraphQL */ `
  subscription OnCreateLocacion($filter: ModelSubscriptionLocacionFilterInput) {
    onCreateLocacion(filter: $filter) {
      id
      locacion
      espacio
      espacioOcupado
      ocupado
      recibaSerialID
      recibaSerialMPID
      fechaDeOcupacion
      fechaDeliberacion
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateLocacion = /* GraphQL */ `
  subscription OnUpdateLocacion($filter: ModelSubscriptionLocacionFilterInput) {
    onUpdateLocacion(filter: $filter) {
      id
      locacion
      espacio
      espacioOcupado
      ocupado
      recibaSerialID
      recibaSerialMPID
      fechaDeOcupacion
      fechaDeliberacion
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteLocacion = /* GraphQL */ `
  subscription OnDeleteLocacion($filter: ModelSubscriptionLocacionFilterInput) {
    onDeleteLocacion(filter: $filter) {
      id
      locacion
      espacio
      espacioOcupado
      ocupado
      recibaSerialID
      recibaSerialMPID
      fechaDeOcupacion
      fechaDeliberacion
      orden
      activo
      Reg_Ins_Usuario
      Reg_Mod_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCambios = /* GraphQL */ `
  subscription OnCreateCambios($filter: ModelSubscriptionCambiosFilterInput) {
    onCreateCambios(filter: $filter) {
      id
      tabla
      valorAnterior
      valorActual
      Reg_Ins_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateCambios = /* GraphQL */ `
  subscription OnUpdateCambios($filter: ModelSubscriptionCambiosFilterInput) {
    onUpdateCambios(filter: $filter) {
      id
      tabla
      valorAnterior
      valorActual
      Reg_Ins_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteCambios = /* GraphQL */ `
  subscription OnDeleteCambios($filter: ModelSubscriptionCambiosFilterInput) {
    onDeleteCambios(filter: $filter) {
      id
      tabla
      valorAnterior
      valorActual
      Reg_Ins_Usuario
      createdAt
      updatedAt
      __typename
    }
  }
`;
